'use client';

import React from 'react';
import { useRef, useState, useEffect } from 'react';
import { useIsFetching } from '@tanstack/react-query';
import { useRegionCurrency } from '@skin-seoul/service';
import MotionLoaderBackdrop from '@/components/ui/MotionLoader/MotionLoaderBackdrop';
const MIN_VISIBLE_MS = 400;
const CurrencyUpdateBackdrop = () => {
  const {
    currency
  } = useRegionCurrency();
  const previousCurrencyRef = useRef(currency);
  const [isSwitching, setIsSwitching] = useState(false);
  const switchStartedAtRef = useRef<number | null>(null);

  // Track fetching state for cart (currency-dependent)
  const cartFetchingCount = useIsFetching({
    queryKey: ['cart']
  });
  useEffect(() => {
    if (previousCurrencyRef.current !== currency) {
      previousCurrencyRef.current = currency;
      setIsSwitching(true);
      switchStartedAtRef.current = Date.now();
    }
  }, [currency]);
  useEffect(() => {
    if (!isSwitching) {
      return;
    }
    if (cartFetchingCount === 0) {
      const startedAt = switchStartedAtRef.current ?? Date.now();
      const elapsed = Date.now() - startedAt;
      const remaining = Math.max(0, MIN_VISIBLE_MS - elapsed);
      const timer = setTimeout(() => {
        setIsSwitching(false);
        switchStartedAtRef.current = null;
      }, remaining);
      return () => clearTimeout(timer);
    }
  }, [isSwitching, cartFetchingCount]);
  return <MotionLoaderBackdrop isVisible={isSwitching} message="Updating Location..." colorScheme="brand" showMessage={false} size="lg" data-testid="currency-update-backdrop" data-sentry-element="MotionLoaderBackdrop" data-sentry-component="CurrencyUpdateBackdrop" data-sentry-source-file="CurrencyUpdateBackdrop.tsx" />;
};
export default CurrencyUpdateBackdrop;